export const CHANGE_LANGUAGE = "CHANGE_LANGUAGE"
export const CHANGE_TYPES = "CHANGE_TYPES"
export const CHANGE_BRANDS = "CHANGE_BRANDS"
export const CHANGE_NOTFICATIONS_COUNT = "CHANGE_NOTFICATIONS_COUNT"
export const CHANGE_GENERAL_SETTINGS = "CHANGE_GENERAL_SETTINGS"
export const CHANGE_TOKEN = "CHANGE_TOKEN"
export const CHANGE_USER_DETAILS = "CHANGE_USER_DETAILS"
export const CHANGE_CARS = "CHANGE_CARS"